import { defineStore } from 'pinia'
import { markRaw } from 'vue'

const useTimezonesStore = defineStore('timezones', {
  state: () => ({
    timezones: markRaw([
      { id: 1, label: 'GMT', value: 'GMT' },
      { id: 3, label: 'Central', value: 'America/Chicago' },
      { id: 4, label: 'Mountain', value: 'America/Denver' },
      { id: 6, label: 'Mountain no DST', value: 'America/Phoenix' },
      { id: 8, label: 'Pacific', value: 'America/Los_Angeles' },
      { id: 9, label: 'Alaska', value: 'America/Anchorage' },
      { id: 10, label: 'Hawaii', value: 'America/Adak' },
      { id: 11, label: 'Hawaii no DST', value: 'Pacific/Honolulu' },
      { id: 13, label: 'Eastern', value: 'America/New_York' },
      { id: 15, label: 'Tegucigalpa, Honduras', value: 'America/Tegucigalpa' },
      { id: 16, label: 'Mexico City', value: 'America/Guatemala' },
      { id: 17, label: 'Canarian islands', value: 'Atlantic/Canary' },
      { id: 18, label: 'Middle European Time', value: 'Europe/Berlin' },
      { id: 19, label: 'Panamá', value: 'America/Panama' },
      { id: 20, label: 'Costa Rica', value: 'America/Costa_Rica' },
      { id: 21, label: 'Argentina/Buenos Aires', value: 'America/Argentina/Buenos_Aires' },
      { id: 22, label: 'Chile', value: 'America/Santiago' },
      { id: 23, label: 'Perú', value: 'America/Lima' },
      { id: 24, label: 'Bogotá', value: 'America/Bogota' },
      { id: 25, label: 'Toronto', value: 'America/Toronto' },
      { id: 26, label: 'Vancouver', value: 'America/Vancouver' },
      { id: 27, label: 'Edmonton', value: 'America/Edmonton' },
      { id: 28, label: 'Halifax', value: 'America/Halifax' },
      { id: 29, label: 'St. Johns', value: 'America/St_Johns' },
      // { id: 30, label: 'Guatemala', value: 'America/Guatemala' },
      { id: 31, label: 'El Salvador', value: 'America/El_Salvador' },
      { id: 32, label: 'Caracas', value: 'America/Caracas' },
      { id: 33, label: 'Guyana', value: 'America/Guyana' },
      { id: 34, label: 'Asuncion', value: 'America/Asuncion' },
      { id: 35, label: 'Montevideo', value: 'America/Montevideo' },
      { id: 36, label: 'La Paz, Bolivia', value: 'America/La_Paz' },
      { id: 37, label: 'Brasilia', value: 'America/Brasilia' },
      { id: 38, label: 'Cuiaba', value: 'America/Cuiaba' },
      { id: 39, label: 'Sao Paulo', value: 'America/Sao_Paulo' },
      { id: 40, label: 'Manaus', value: 'America/Manaus' },
      { id: 41, label: 'Bahia', value: 'America/Bahia' },
      { id: 42, label: 'Fortaleza', value: 'America/Fortaleza' },
      { id: 43, label: 'Guayaquil', value: 'America/Guayaquil' },
      { id: 44, label: 'Merida', value: 'America/Merida' },
      { id: 45, label: 'Cancun', value: 'America/Cancun' },
      { id: 46, label: 'Monterrey', value: 'America/Monterrey' },
      { id: 47, label: 'Chihuahua', value: 'America/Chihuahua' },
      { id: 48, label: 'Hermosillo', value: 'America/Hermosillo' },
      { id: 49, label: 'Mazatlan', value: 'America/Mazatlan' },
      { id: 50, label: 'Tijuana', value: 'America/Tijuana' },
      { id: 51, label: 'Reynosa / Matamoros', value: 'America/Matamoros' }
    ])
  })
})

export default useTimezonesStore
